import { render } from "./ComingSoonView.vue?vue&type=template&id=c12fa2de&scoped=true"
import script from "./ComingSoonView.vue?vue&type=script&lang=js"
export * from "./ComingSoonView.vue?vue&type=script&lang=js"

import "./ComingSoonView.vue?vue&type=style&index=0&id=c12fa2de&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_db7f3463623555724ece677ccfae2485/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12fa2de"]])

export default __exports__